import script from "./SchoolListContent.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolListContent.vue?vue&type=script&setup=true&lang=js"

import "./SchoolListContent.vue?vue&type=style&index=0&id=45a68948&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45a68948"]])

export default __exports__